export const setupCSPReporting = () => {
  if (typeof document !== "undefined") {
    document.addEventListener("securitypolicyviolation", (e) => {
      const violationReport = {
        documentURI: e.documentURI,
        violatedDirective: e.violatedDirective,
        effectiveDirective: e.effectiveDirective,
        originalPolicy: e.originalPolicy,
        blockedURI: e.blockedURI,
        sourceFile: e.sourceFile,
        lineNumber: e.lineNumber,
        columnNumber: e.columnNumber,
        statusCode: e.statusCode,
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
      };
      console.warn("CSP Violation:", violationReport);
    });
  }
};

export const getCSPNonce = () => {
  if (typeof document !== "undefined") {
    const metaNonce = document.querySelector('meta[property="csp-nonce"]');
    return metaNonce ? metaNonce.getAttribute("content") : null;
  }
  return null;
};
